import type { IconData } from '@stacksjs/iconify-core'

export const testTubeFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 1.5c-5.809 0-10.402.317-13.313.595c-1.964.187-2.823 2.446-1.59 3.936l2.88 3.482v16.058c0 4.13.073 7.653.171 10.52c.191 5.55 4.295 10.176 9.904 10.374a55 55 0 0 0 3.961-.002c5.577-.203 9.657-4.787 9.843-10.306c.097-2.845.168-6.373.168-10.586V9.513l2.88-3.482c1.232-1.49.372-3.749-1.59-3.936C34.401 1.817 29.807 1.5 24 1.5\"/><path fill=\"#2859c5\" d=\"M12.113 35H17a2 2 0 1 0 0-4h-4.98q.037 2.157.093 4m-.137-9H17a2 2 0 1 0 0-4h-5.024zm0-9H17a2 2 0 1 0 0-4h-5.024z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default testTubeFlat
